
import { DirectiveOptions } from 'vue'
let num = 0
export const scroll:DirectiveOptions = {
  bind (el:HTMLBodyElement, binding,vnode) {
    // const SELECTWRAPDOM:HTMLBodyElement = el.querySelector("el-select-dropdown__wrap el-scrollbar__wrap")
    // console.log(el)
    // SELECTWRAPDOM.addEventListener('scroll',function(){
    //   const CONDITION = this.scrollHeight- this.scrollTop <= this .clientHeight
    //   if(CONDITION){
    //     binding.value()
    //     console.log('触底了')
    //   }
    // })
  },
  unbind(el){
    num = 0
  }
}